export const DEFAULT_LOGO_UPDATE_ALERT =
  'Recomendamos uma resolução de 225 x 225 pixels, e aceitamos até 490 x 490.';
